import { render, staticRenderFns } from "./tutorialsAction.vue?vue&type=template&id=66816125&scoped=true&"
import script from "./tutorialsAction.vue?vue&type=script&lang=js&"
export * from "./tutorialsAction.vue?vue&type=script&lang=js&"
import style0 from "./tutorialsAction.vue?vue&type=style&index=0&id=66816125&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66816125",
  null
  
)

export default component.exports